import ApiService from '../../service/apiServiceMasterWs.js';
import ApiServiceMasterCache from '../../service/apiServiceMasterCache.js';

const querystring = require('querystring')
var WorkSpaceTeamService = {

    findAll: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "workspaceteams"
            $options.method = "get"

            if ($data) {
                $options.url = "workspaceteams?" + querystring.stringify($data)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },

    getOneUserWs: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getOneUserWs"
            $options.method = "get"

            if ($data) {
                $options.url = "getOneUserWs?" + querystring.stringify($data)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    findOneWorkSpace: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "workspaceteam"
            $options.method = "get"

            if ($data) {
                $options.url = "workspaceteam?" + querystring.stringify($data)
            }
            ApiServiceMasterCache.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
  
    findOne: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "workspaceteams/" + $data
            console.log($options.url)
            $options.method = "get"
            if (!$data) {
                $options.data = $data
            }
            ApiServiceMasterCache.request($options)
                .then(response => {
                    // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });

    },
    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "workspaceteams/" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        })
    },
    save: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "workspaceteams" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },

    create: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "workspaceteams";
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },
    membersRestriction: function($data){
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "membersRestriction"
            $options.method = "get"
            if ($data) {
                $options.url = "membersRestriction?" + querystring.stringify($data)
            }
            ApiService.request($options).then(response=>{
                resolve(response.data.data)
            }).catch(error=>{
                reject(error)
            });
        })
    }
};
export default WorkSpaceTeamService;